import { get, writable } from "svelte/store";
export const notifications = writable([]);
export function showNotification(notification) {
    const allNotifications = get(notifications);
    if (allNotifications.includes(notification)) {
        return;
    }
    notifications.set([...allNotifications, notification]);
    setTimeout(() => removeNotification(notification), 10000);
}
export function removeNotification(notification) {
    const allNotifications = get(notifications);
    if (!allNotifications.includes(notification)) {
        return;
    }
    notifications.set(allNotifications.filter(_notification => _notification !== notification));
}
